import { ListBoxIcon } from './ListBoxIcon';

/**
 * author: frankgrinaert
 * id E1277D63-636E-479A-974A-83901A84A8F0
 * name list-box
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/list-box.svg
 * tags
 */
export const FormIcon = ListBoxIcon;
export default FormIcon